// extracted by mini-css-extract-plugin
export default {"productDescription":"gca-z","featuredDescription":"hca-z","description":"ica-z","more":"jca-z","descriptionSku":"kca-z"};